import { get } from './http';

const dictUrl = process.env.VUE_APP_DICT_URL;

// 获取用户登录状态
const getAccountInfo = () => get(`${dictUrl}/login/acc/query/accountinfo`);
// 获取用户昵称
const getNickname = (params) => get(`${dictUrl}/profile/batch/get?content=${encodeURIComponent(JSON.stringify(['option_avatar', 'nickname']))}`, params);

export default {
  getAccountInfo,
  getNickname,
}
